import { PropsWithChildren } from 'react';

import { H1 } from '@betterment/samba-react';

type StepHeadingProps = {
  isCentered?: boolean;
};

const StepHeading: React.FC<PropsWithChildren<StepHeadingProps>> = ({ children, isCentered }) => {
  return (
    <H1
      css={{
        textAlign: isCentered ? 'center' : 'left',
        fontSize: {
          lgDown: '28px',
          mdDown: 'fontSize.300',
        },
        textWrap: 'wrap',
        lineHeight: 'lineHeight.300',
      }}
    >
      {children}
    </H1>
  );
};

export default StepHeading;
